// Icon name mapping to Lucide icon component names
const iconNameMap: Record<string, string> = {
  dashboard: "LayoutDashboard",
  bot: "Bot",
  "chart-bar": "BarChart3",
  calendar: "Calendar",
  briefcase: "Briefcase",
  clock: "Clock",
  users: "Users",
  gift: "Gift",
  package: "Package",
  "shopping-cart": "ShoppingCart",
  "credit-card": "CreditCard",
  wallet: "Wallet",
  ticket: "Ticket",
  megaphone: "Megaphone",
  share: "Share2",
  lightbulb: "Lightbulb",
  "user-tie": "UserCog",
  "calendar-clock": "CalendarClock",
  globe: "Globe",
  settings: "Settings",
  home: "Home",
  search: "Search",
  menu: "Menu",
  "chevron-right": "ChevronRight",
  "chevron-down": "ChevronDown",
  x: "X",
  plus: "Plus",
  minus: "Minus",
  edit: "Pencil",
  trash: "Trash2",
  check: "Check",
  "alert-circle": "AlertCircle",
  info: "Info",
  warning: "AlertTriangle",
  error: "XCircle",
  success: "CheckCircle",
  logout: "LogOut",
  login: "LogIn",
  user: "User",
  mail: "Mail",
  phone: "Phone",
  location: "MapPin",
  link: "Link",
  image: "Image",
  file: "File",
  folder: "Folder",
  download: "Download",
  upload: "Upload",
  refresh: "RefreshCw",
  filter: "Filter",
  sort: "ArrowUpDown",
  eye: "Eye",
  "eye-off": "EyeOff",
  lock: "Lock",
  unlock: "Unlock",
  star: "Star",
  heart: "Heart",
  bookmark: "Bookmark",
  flag: "Flag",
  tag: "Tag",
  copy: "Copy",
  clipboard: "Clipboard",
  printer: "Printer",
  save: "Save",
  send: "Send",
  archive: "Archive",
  "external-link": "ExternalLink",
  "heart-handshake": "HeartHandshake"
};

export const resolveIconComponentName = (iconName: string): string | undefined => {
  if (!iconName || iconName.trim().length === 0) {
    return undefined;
  }

  const normalized = iconName.toLowerCase().trim();

  // Check direct mapping
  if (iconNameMap[normalized]) {
    return iconNameMap[normalized];
  }

  // Try PascalCase conversion
  const pascalCase = normalized
    .split(/[-_\s]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join("");

  return pascalCase;
};
